export default {
  "WorkspacesLinks": "_WorkspacesLinks_12vhn_1"
};import "ni:sha-256;QEJ1FYDD2vrVNynXDxybagwh1ZQlSSAytQ1KFQw4SR4";